<script setup lang="ts">
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { useTypedIntl } from "@/locales/typed-intl";

import DashboardDialog from "@/components/data/dashboard/dashboard-dialog.vue";

const visible = defineModel<boolean>();

const { t, k } = useTypedIntl();
</script>

<template>
  <DashboardDialog
    v-model:visible="visible"
    :data-test-id="DATA_TEST_IDS.views.dashboard.consumptionHighVariation.dialog"
  >
    <template #title>
      <h4>
        {{ t(k.data.dashboard.insights.consumptionEvolution.highVariation.warning) }}
      </h4>
    </template>

    <template #subtitle>
      <span class="text-text-secondary">{{ t(k.data.dashboard.insights.consumptionEvolution.subtitle) }}</span>
    </template>

    <span>
      {{ t(k.data.dashboard.insights.consumptionEvolution.highVariation.details) }}
    </span>
  </DashboardDialog>
</template>
